import React from "react";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  const projects = [
    { key: "bellemare", name: "BelleMare" },
    { key: "botanicheska302", name: "Botanicheska 302" },
    { key: "fifthelement", name: "Fifth Element" },
    { key: "garden", name: "Gradina" },
    { key: "m2", name: "M2" },
    { key: "paradisepark", name: "Paradise Park" },
    { key: "prestigepark", name: "Prestige Park" },
    { key: "theframe", name: "The Frame" },
    { key: "grandparkliving", name: "Grand Park & Living" }
  ];

  return (
    <footer style={{ 
      backgroundColor: '#ffffff', 
      padding: '80px 0 40px',
      borderTop: '1px solid #f0f0f0'
    }}>
      <div className="container" style={{ maxWidth: '1400px' }}>
        {/* Main Footer Content */}
        <div style={{ marginBottom: '60px' }}>
          <div className="row">
            {/* Company Info Section */}
            <div className="col-lg-4 col-md-6 mb-5">
              <div style={{ marginBottom: '30px' }}>
                <a href="/" style={{ display: 'inline-block', textDecoration: 'none' }}>
                  <img 
                    src="/home1/assets/img/logo_light.png" 
                    alt="OneArt Construction" 
                    style={{ 
                      height: '50px', 
                      width: 'auto',
                      marginBottom: '20px'
                    }} 
                  />
                </a>
                <p style={{
                  fontSize: '1rem',
                  color: '#6b7280',
                  lineHeight: '1.6',
                  marginBottom: '30px'
                }}>
                  {t("footer.company.description")}
                </p>
                <div style={{ display: 'flex', gap: '15px' }}>
                  <a 
                    href="https://www.facebook.com/profile.php?id=61578008546140&mibextid=wwXIfr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link"
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6b7280',
                      textDecoration: 'none',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: 'translateY(0)',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a 
                    href="https://www.instagram.com/botanicheska302?igsh=aDZ3NWp6Z2x6aWpy" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link"
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6b7280',
                      textDecoration: 'none',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: 'translateY(0)',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/oneart-construction" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link"
                    style={{
                      width: '40px',
                      height: '40px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#6b7280',
                      textDecoration: 'none',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: 'translateY(0)',
                      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Projects Section */}
            <div className="col-lg-4 col-md-6 mb-5">
              <h5 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1a1a1a',
                marginBottom: '25px',
                fontFamily: 'Montserrat, sans-serif'
              }}>
                {t("footer.projects.title")}
                </h5>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
                {projects.map((project) => (
                  <a 
                    key={project.key}
                    href={`/projects/${project.key}`}
                    className="project-link"
                    style={{
                      color: '#6b7280',
                      textDecoration: 'none',
                      fontSize: '0.95rem',
                      padding: '8px 0',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      borderBottom: '1px solid transparent',
                      transform: 'translateX(0)',
                      position: 'relative'
                    }}
                  >
                    {project.name}
                  </a>
                ))}
              </div>
            </div>

            {/* Contact Info Section */}
            <div className="col-lg-4 col-md-6">
              <h5 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1a1a1a',
                marginBottom: '25px',
                fontFamily: 'Montserrat, sans-serif'
              }}>
                {t("footer.contact.title")}
                </h5>
              <div style={{ marginBottom: '30px' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  marginBottom: '20px' 
                }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    color: 'rgb(73, 69, 56)',
                    marginRight: '15px',
                    marginTop: '2px',
                    flexShrink: 0
                  }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                    </svg>
                  </div>
                  <div>
                    <p style={{ 
                      color: '#6b7280', 
                      fontSize: '0.95rem', 
                      margin: 0,
                      lineHeight: '1.5'
                    }}>
                      {t("footer.contact.address")}
                    </p>
                  </div>
                </div>

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  marginBottom: '20px' 
                }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    color: 'rgb(73, 69, 56)',
                    marginRight: '15px',
                    marginTop: '2px',
                    flexShrink: 0
                  }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                  </div>
                  <div>
                    <a 
                      href="tel:+359887770900" 
                      className="contact-link"
                      style={{
                        color: '#6b7280',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: 'translateX(0)',
                        position: 'relative'
                      }}
                    >
                      {t("footer.contact.phone")}
                    </a>
                  </div>
                </div>

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start' 
                }}>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    color: 'rgb(73, 69, 56)',
                    marginRight: '15px',
                    marginTop: '2px',
                    flexShrink: 0
                  }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                    </svg>
                  </div>
                  <div>
                    <a 
                      href="mailto:office@artstroy.bg" 
                      className="contact-link"
                      style={{
                        color: '#6b7280',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: 'translateX(0)',
                        position: 'relative'
                      }}
                    >
                      {t("footer.contact.email")}
                    </a>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div style={{ 
          borderTop: '1px solid #f0f0f0', 
          paddingTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div>
            <p style={{ 
              color: '#9ca3af', 
              fontSize: '0.9rem', 
              margin: 0 
            }}>
              {t("footer.copyright")}
            </p>
              </div>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <a 
              href="/innerpages/terms" 
              className="legal-link"
              style={{
                color: '#9ca3af',
                textDecoration: 'none',
                fontSize: '0.9rem',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                transform: 'translateY(0)',
                position: 'relative'
              }}
            >
              {t("footer.legal.terms")}
            </a>
            <span style={{ color: '#e5e7eb' }}>|</span>
            <a 
              href="/innerpages/terms" 
              className="legal-link"
              style={{
                color: '#9ca3af',
                textDecoration: 'none',
                fontSize: '0.9rem',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                transform: 'translateY(0)',
                position: 'relative'
              }}
            >
              {t("footer.legal.privacy")}
            </a>
          </div>
        </div>
      </div>

      {/* Enhanced CSS with Hover Effects */}
      <style>{`
        /* Font Awesome Icons - Ensure proper font-family for Font Awesome 6 */
        .social-link .fab,
        .social-link i.fab,
        .social-link i[class*="fa-"] {
          font-family: "Font Awesome 6 Brands" !important;
          font-weight: 400 !important;
          font-style: normal !important;
        }
        
        /* Social Links Hover Effects */
        .social-link:hover {
          background-color: rgb(73, 69, 56) !important;
          color: #ffffff !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 12px rgba(73, 69, 56, 0.3) !important;
        }
        
        .social-link:hover .fab,
        .social-link:hover i.fab,
        .social-link:hover i[class*="fa-"] {
          color: #ffffff !important;
        }

        /* Project Links Hover Effects */
        .project-link:hover {
          color: rgb(73, 69, 56) !important;
          transform: translateX(4px) !important;
        }

        .project-link:hover::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: rgb(73, 69, 56);
          transform: scaleX(1);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .project-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: rgb(73, 69, 56);
          transform: scaleX(0);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Contact Links Hover Effects */
        .contact-link:hover {
          color: rgb(73, 69, 56) !important;
          transform: translateX(4px) !important;
        }

        .contact-link:hover::before {
          content: '→';
          position: absolute;
          left: -20px;
          color: rgb(73, 69, 56);
          font-weight: bold;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Legal Links Hover Effects */
        .legal-link:hover {
          color: rgb(73, 69, 56) !important;
          transform: translateY(-1px) !important;
        }

        .legal-link:hover::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: rgb(73, 69, 56);
          transform: scaleX(1);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .legal-link::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: rgb(73, 69, 56);
          transform: scaleX(0);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Responsive Design */
        @media (max-width: 991px) {
          footer {
            padding: 60px 0 30px !important;
          }
          .col-lg-4 {
            margin-bottom: 40px;
          }
        }

        @media (max-width: 767px) {
          footer {
            padding: 50px 0 30px !important;
          }
          .col-lg-4 {
            margin-bottom: 30px;
          }
          .footer-bottom {
            flex-direction: column !important;
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
